module.exports = __webpack_public_path__ + "static/img/DirectLink.a710866b.png";